import * as yup from 'yup';
import { generateSelectYears } from 'util/date';
import { MONTHS_OF_YEAR } from 'constants/date';

export const initialValues = {

  eventDate: '',
  waitingForDecision: false,
};

export const schema = yup.object().shape({

  eventDate: yup.string(),
  waitingForDecision: yup.boolean(),
});

export const monthsOptions = MONTHS_OF_YEAR.map((month, i) => ({
  value: i + 1,
  label: month,
}));

export const yearsOptions = generateSelectYears({ numberOfYears: 2 }).map(
  (year) => ({
    value: year,
    label: year,
  })
);
